import { FC } from 'react';

import { usePrivateLayout } from '~/layouts/private/providers/privateLayout';

import { CircularGlow } from '~/common/components/CircularGlow';

import { Overlay, StyledDrawer } from './styles';
import { SatoshiContent } from '../SatoshiContent';

interface ISatoshiDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}
export const SatoshiDrawer: FC<ISatoshiDrawerProps> = ({ isOpen, onClose }) => {
  const { isMobile } = usePrivateLayout();
  return (
    <>
      <Overlay isOpen={isOpen} onClick={onClose} />
      <StyledDrawer isOpen={isOpen}>
        {!isMobile && (
          <CircularGlow
            top="0%"
            width="500px"
            animationBreathingTime="200s"
            height="100px"
            opacity={0.4}
          />
        )}

        {isOpen && <SatoshiContent close={onClose} />}
      </StyledDrawer>
    </>
  );
};
